<template>
  <div class="bg-grey overflow-hidden rounded-[20px]">
    <h3>
      <button
        class="flex w-full cursor-pointer items-center justify-between gap-x-5 p-4 pl-8 text-left"
        type="button"
        :aria-expanded="isExpanded"
        @click="toggle"
      >
        <span
          class="text-[18px]/[1.3em] font-medium tracking-[0.01em] md:text-[22px]"
          v-text="question"
        />
        <span
          class="flex h-13 w-13 flex-none items-center justify-center rounded-full bg-white"
        >
          <svg
            class="h-4 w-4 transition-transform duration-300"
            :class="isExpanded ? 'rotate-180' : ''"
            viewBox="0 0 16 16"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            aria-hidden="true"
          >
            <path d="M4 6l4 4 4-4" />
          </svg>
        </span>
      </button>
    </h3>
    <BaseExpandingWrapper :open="isExpanded">
      <div class="rich-text px-8 pb-8 text-[16px]/[1.4em]">
        <PayloadRichText :content="answer" />
      </div>
    </BaseExpandingWrapper>
  </div>
</template>

<script setup lang="ts">
import type { FaqItems, GoodQuestion } from '#payload-types'

interface Props {
  question: string
  index: number
  /** Which FAQ list this sits in, reported as `faq_section`. */
  section: string
  // The home page's "good questions" and the SA page's FAQ are separate Payload fields with
  // the same rich-text shape, so this renders either.
  answer: GoodQuestion['answer'] | NonNullable<FaqItems>[number]['answer']
}

const props = defineProps<Props>()

const isExpanded = ref(false)

const toggle = () => {
  isExpanded.value = !isExpanded.value
  trackEvent('faq_toggle', {
    faq_question: props.question.slice(0, 100),
    faq_index: props.index,
    faq_section: props.section,
    action: isExpanded.value ? 'open' : 'close',
  })
}
</script>
